import { createSlice } from '@reduxjs/toolkit';
export const userAgentSlice = createSlice({
    name: 'userAgent',
    initialState: {
        UA: null,
        registerer: null,
        state: 'init',
        incomingCalls: [],
        attemptingReconnect: false,
        reconnectionAttempt: 0,
        oneSameServerReconnect: true,
        doNotDisturb: false,
    },
    reducers: {
        setUA: (state, action) => {
            state.UA = action.payload;
        },
        setRegisterer: (state, action) => {
            state.registerer = action.payload;
        },
        setUAState: (state, action) => {
            state.state = action.payload;
        },
        setIncomingCalls: (state, action) => {
            state.incomingCalls = action.payload
        },
        setAttemptReconnect: (state, action) => {
            state.attemptingReconnect = action.payload;
        },
        setDoNotDisturb: (state, action) => {
            state.doNotDisturb = action.payload;
        },
        toggleDoNotDisturb: (state) => {
            state.doNotDisturb = !state.doNotDisturb;
        },
        incReconnectionAttempt: (state) => {
            state.reconnectionAttempt += 1;
        },
        setOneSameServerReconnect: (state, action) => {
            state.oneSameServerReconnect = action.payload;
        },
        resetUserAgent: (state) => {
            state.UA = null;
            state.registerer = null;
            state.state = 'init';
            state.attemptingReconnect = false;
            state.reconnectionAttempt = 0;
            state.oneSameServerReconnect = true;
            state.doNotDisturb = false;
        },
    }
});

export const { setUA, setRegisterer, setUAState, setIncomingCalls, setAttemptReconnect, incReconnectionAttempt, setOneSameServerReconnect, setDoNotDisturb, toggleDoNotDisturb, resetUserAgent } = userAgentSlice.actions;

//selectors
export const selectUA = (state) => state.userAgent.UA;
export const selectRegisterer = (state) => state.userAgent.registerer;
export const selectUAState = (state) => state.userAgent.state;
export const selectIncomingCalls = (state) => state.userAgent.incomingCalls;
export const selectAttemptingReconnect = (state) => state.userAgent.attemptingReconnect;
export const selectReconnectionAttempt = (state) => state.userAgent.reconnectionAttempt;
export const selectOneSameServerReconnect = (state) => state.userAgent.oneSameServerReconnect;
export const selectDoNotDisturb = (state) => state.userAgent.doNotDisturb;

export default userAgentSlice.reducer;

